<script>
/** Match body to root so rubber-band overscroll doesn’t flash a different color. */
const BODY_SURFACE = ['tw-bg-white', 'md:tw-bg-light-bg'];

/**
 * Standalone public pages (shared links, coupon lookup, OAuth redirect).
 * Not the login/register shell — keep that in auth.vue.
 */
export default {
  name: 'PublicLayout',
  created() {
    document.body.classList.add('public-layout', ...BODY_SURFACE);
  },
  beforeDestroy() {
    document.body.classList.remove('public-layout', ...BODY_SURFACE);
  },
}
</script>

<template>
  <div class="public-layout-root tw-min-h-screen tw-bg-white md:tw-bg-light-bg">
    <slot/>
  </div>
</template>
